<div class="clipboard">
  <span class="icon copy-clipboard text-grey-400 copyBtn" ngxClipboard [cbContent]="clipboardContent" [matTooltip]="text" (click)="clipboardClick(true); onClipBoardClick.emit(); $event.stopPropagation()" (mouseleave)="clipboardClick(false)"></span>
</div>
